/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable functional/no-conditional-statement */
import { fetchPostProductsPricingLookup } from "../../cart-manual-entry-form/miscellaneous/fetchPostProductsPricingLookup";
import { definitions } from "../../common-fetch/generated/orders-model-api";
import { removeDuplicate } from "../../common/miscellaneous/removeDuplicate";
import { LookupPricingState } from "./lookupPricingAtom";
import { CartAndOrder } from "./orderAtom";

export async function getProductPricingLookup(orders: CartAndOrder) {
  const orderLines = orders.orderLines;
  const uquiParts = removeDuplicate(
    orderLines as string[],
    "manufacturerPartNumber"
  ) as definitions["OrderLineDto"][];

  if (uquiParts.length > 0) {
    const partNumbers = uquiParts.map(
      (item) => item.manufacturerPartNumber
    ) as string[];

    const pricingLookup = await fetchPostProductsPricingLookup(partNumbers);

    if (pricingLookup.tag === "successful") {
      return pricingLookup.parsed as LookupPricingState;
    }
  }

  return [];
}
